import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Notification } from "../common/models/notification";

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    public subject = new Subject<Notification>();
    public notification?: Notification;

    public notificationClicked(notification: Notification) {
        this.subject.next(notification);
    }
}
